export default __webpack_public_path__ + "static/media/27.9bd52712.jpg";